import {MapSettingEnum, ModeSettingEnum} from '@colonist/game-base-types'

export interface FeaturedTournamentData {
    title: string
    url: string
    detail: string
    startDate: string
    endDate: string
    organizer: string
    bannerImage: string
    monthlyLeague: boolean
    displayedDate?: string
}

export interface FeaturedContentData {
    tournaments: FeaturedTournamentData[]
}

export const nonFeaturedGameMaps = new Set([
    MapSettingEnum.Classic4P,
    MapSettingEnum.Classic4PRandom,
    MapSettingEnum.TutorialSS1HeadingForNewShores4P,
    MapSettingEnum.TutorialSS2FourIslands4P,
    MapSettingEnum.TutorialSS3FogIsland4P,
    MapSettingEnum.TutorialSS4ThroughTheDesert4P,
])

export const nonFeaturedGameModes = new Set([
    ModeSettingEnum.Classic4P,
    ModeSettingEnum.ServerStressTestClassic4P,
    ModeSettingEnum.BeginnerModeClassic4P,
])
